export enum BoneModelType {
  Raw = 'Raw',
  Draft = 'Draft',
  Temporary = 'Temporary',
}
